import React from 'react';
import fixedHeight from 'components/common/FixedHeight';

export default fixedHeight(({ props, children}) => (
  <div>{children}</div>
));


// WEBPACK FOOTER //
// ./src/components/BookingFormWrap.js